import { render, staticRenderFns } from "./LastMonth.vue?vue&type=template&id=8878c3f0&"
import script from "./LastMonth.vue?vue&type=script&lang=ts&"
export * from "./LastMonth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports